import { render, staticRenderFns } from "./Part4.vue?vue&type=template&id=63292d22&scoped=true"
import script from "./Part4.vue?vue&type=script&lang=js"
export * from "./Part4.vue?vue&type=script&lang=js"
import style0 from "./Part4.vue?vue&type=style&index=0&id=63292d22&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63292d22",
  null
  
)

export default component.exports